/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsDeleteServiceMutationVariables = {
    serviceID: string;
};
export type mutationsDeleteServiceMutationResponse = {
    readonly deleteService: boolean;
};
export type mutationsDeleteServiceMutation = {
    readonly response: mutationsDeleteServiceMutationResponse;
    readonly variables: mutationsDeleteServiceMutationVariables;
};



/*
mutation mutationsDeleteServiceMutation(
  $serviceID: ID!
) {
  deleteService(input: {serviceID: $serviceID})
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "serviceID",
            "variableName": "serviceID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteService",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsDeleteServiceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsDeleteServiceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7d5ccf0c3fc54910805fd20e4a76d29",
    "id": null,
    "metadata": {},
    "name": "mutationsDeleteServiceMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsDeleteServiceMutation(\n  $serviceID: ID!\n) {\n  deleteService(input: {serviceID: $serviceID})\n}\n"
  }
};
})();
(node as any).hash = 'f3941cdbf1b03182ed83b77051a70648';
export default node;
